// extracted by mini-css-extract-plugin
export default {"container":"line-spacer_container__3Jx5Y","label":"line-spacer_label__3wjCs","line":"line-spacer_line__ebCYS"};